import type { User } from '../../types/auth'

/**
 * A manager/caddiemaster tied to a CLUB (course-owning) tenant can set that club's
 * weather status. SOCIETY/UNION tenants have no physical course, so the control is
 * hidden for them (ADR-092/093).
 */
export const canManageWeather = (user?: User | null): boolean =>
  !!(user?.tenantId != null &&
    user.tenantType !== 'SOCIETY' &&
    user.tenantType !== 'UNION' &&
    (user.roles?.includes('MANAGER') || user.roles?.includes('CADDIEMASTER')))
